import { CEDeficiencyAttributesBase } from './ce-deficiency-attributes-base'


export class CEDeficiencyAttributes extends CEDeficiencyAttributesBase {

}